"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _common = require("../../common");

var _lib = require("../../lib");

var _InputWrapper = _interopRequireDefault(require("../InputWrapper"));

var _Validate = require("../Validate");

var _Base = _interopRequireDefault(require("./Base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Textarea =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Textarea, _PureComponent);

  function Textarea() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Textarea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Textarea)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      focus: false
    });

    _defineProperty(_assertThisInitialized(_this), "innerRef", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "focus", function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick; // fix safari focus bug when multiple Input components inside Label component

      (0, _lib.callEventMethods)(e, 'preventDefault');

      if (disabled) {
        return;
      }

      if (_this.innerRef && _this.innerRef.current) {
        _this.innerRef.current.focus();
      }

      if (onClick) {
        onClick(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e, _ref) {
      var name = _ref.name,
          value = _ref.value;
      (0, _lib.callEventMethods)(e, 'persist', 'stopPropagation');
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          disabled = _this$props2.disabled;

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      if (onChange) {
        onChange(e, {
          name: name,
          value: value
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnFocus", function (e, _ref2) {
      var name = _ref2.name,
          value = _ref2.value;
      (0, _lib.callEventMethods)(e, 'persist');

      if (_this.props.disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      _this.setState({
        focus: true
      }, function () {
        var onFocus = _this.props.onFocus;

        if (onFocus) {
          onFocus(e, {
            name: name,
            value: value
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnBlur", function (e, _ref3) {
      var name = _ref3.name,
          value = _ref3.value;
      (0, _lib.callEventMethods)(e, 'persist');

      if (_this.props.disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      _this.setState({
        focus: false
      }, function () {
        var onBlur = _this.props.onBlur;

        if (onBlur) {
          onBlur(e, {
            name: name,
            value: value
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var names = [Textarea.className];
      (0, _lib.addClassByPropName)(names, _this.props);
      return names.join(' ');
    });

    return _this;
  }

  _createClass(Textarea, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          name = _this$props3.name,
          children = _this$props3.children,
          value = _this$props3.value,
          defaultValue = _this$props3.defaultValue,
          autoResize = _this$props3.autoResize,
          placeholder = _this$props3.placeholder,
          maxLength = _this$props3.maxLength,
          resizable = _this$props3.resizable,
          readOnly = _this$props3.readOnly,
          innerRef = _this$props3.innerRef,
          onChange = _this$props3.onChange,
          onFocus = _this$props3.onFocus,
          onBlur = _this$props3.onBlur,
          rows = _this$props3.rows,
          cols = _this$props3.cols,
          rest = _objectWithoutProperties(_this$props3, ["name", "children", "value", "defaultValue", "autoResize", "placeholder", "maxLength", "resizable", "readOnly", "innerRef", "onChange", "onFocus", "onBlur", "rows", "cols"]);

      var textareaRef = innerRef || this.innerRef;
      var classNames = this.classNames();
      return _react.default.createElement(_InputWrapper.default, _extends({}, rest, {
        readOnly: readOnly,
        focus: this.state.focus,
        className: classNames,
        onClick: this.focus
      }), _react.default.createElement(_Base.default, {
        rows: rows,
        cols: cols,
        autoResize: autoResize,
        maxLength: maxLength,
        innerRef: textareaRef,
        value: value,
        defaultValue: defaultValue,
        name: name,
        placeholder: placeholder,
        disabled: rest.disabled,
        readOnly: readOnly,
        onChange: this.handleOnChange,
        onFocus: this.handleOnFocus,
        onBlur: this.handleOnBlur,
        resizable: resizable
      }), children);
    }
  }]);

  return Textarea;
}(_react.PureComponent);

exports.default = Textarea;

_defineProperty(Textarea, "Validate", (0, _Validate.withValidate)(Textarea));

_defineProperty(Textarea, "Base", _Base.default);

_defineProperty(Textarea, "className", 'MHub-Textarea');

_defineProperty(Textarea, "displayName", 'Textarea');

_defineProperty(Textarea, "propTypes", {
  children: _propTypes.default.node,
  value: _common.customPropTypes.stringOrNumber,
  defaultValue: _common.customPropTypes.stringOrNumber,
  name: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  className: _propTypes.default.string,
  onClick: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  innerRef: _common.customPropTypes.ref,
  rows: _propTypes.default.number,
  cols: _propTypes.default.number,
  maxLength: _propTypes.default.number,
  autoResize: _propTypes.default.bool,
  resizable: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf(['vertical', 'horizontal'])])
});

_defineProperty(Textarea, "defaultProps", {
  children: null,
  value: undefined,
  defaultValue: '',
  name: null,
  placeholder: null,
  className: null,
  onClick: null,
  onChange: null,
  onFocus: null,
  onBlur: null,
  disabled: false,
  readOnly: false,
  innerRef: null,
  rows: null,
  cols: null,
  maxLength: null,
  autoResize: false,
  resizable: true
});